export function createAdminNotificationMeta({ type, summary, nextAttemptAt = new Date() }) {
  return {
    notificationType: type,
    notificationSummary: summary,
    notificationStatus: 'pending',
    notificationAttempts: 0,
    notificationSentAt: null,
    lastNotificationError: null,
    processing: false,
    notificationLockExpiresAt: null,
    nextNotificationAttemptAt: nextAttemptAt,
  };
}
